<template>
  <div
    role="region"
    aria-labelledby="loader-title"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
  >
    <div
      class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
      aria-hidden="true"
    ></div>
    <p id="loader-title" class="text-center text-white text-xl font-semibold">Loading...</p>
    <p class="w-1/3 text-center text-white">This may take a few seconds, please don't close this page.</p>
  </div>
</template>
<script>
export default {
  name: "app-Loader",
  mounted() {
    this.syncAriaHidden();
    this._loaderClassObserver = new MutationObserver(() => this.syncAriaHidden());
    this._loaderClassObserver.observe(this.$el, {
      attributes: true,
      attributeFilter: ["class"],
    });
  },
  beforeUnmount() {
    this._loaderClassObserver?.disconnect();
  },
  methods: {
    syncAriaHidden() {
      const hidden = this.$el.classList.contains("hidden");
      this.$el.setAttribute("aria-hidden", hidden ? "true" : "false");
      this.$el.setAttribute("aria-busy", hidden ? "false" : "true");
    },
  },
};
</script>
